/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type HpRespLayout_viewer = {
    readonly homepage: {
        readonly modules: ReadonlyArray<{
            readonly type?: string | null;
            readonly totalItemsCount?: number | null;
            readonly index?: number | null;
            readonly " $fragmentRefs": FragmentRefs<"HpRespSkinnyBannerModule_componentModule" | "HpRespTopHeroBannerModule_componentModule" | "HpRespHeroModuleOld_componentModule" | "HpRespCollectionsModuleOld_componentModule" | "HpRespFeaturedModule_componentModule" | "HpRespPromoModulePrimaryOld_componentModule" | "HpRespPromoModuleSecondaryOld_componentModule" | "HpRespEditorialModule_componentModule" | "HpRespShopByModule_componentModule" | "HpRespLocationsModule_componentModule" | "HpRespPersonalizedCategories_componentModule" | "HpRespRecentlyViewedItems_componentModule">;
        } | null> | null;
        readonly personalization?: {
            readonly " $fragmentRefs": FragmentRefs<"HpRespPersonalizedCategories_personalization">;
        } | null;
    } | null;
    readonly user?: {
        readonly " $fragmentRefs": FragmentRefs<"HpRespRecentlyViewedItems_user">;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"HpRespPersonalizedCategories_viewer" | "HpRespLocationsModule_viewer">;
    readonly " $refType": "HpRespLayout_viewer";
};
export type HpRespLayout_viewer$data = HpRespLayout_viewer;
export type HpRespLayout_viewer$key = {
    readonly " $data"?: HpRespLayout_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"HpRespLayout_viewer">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "Variable",
  "name": "userId",
  "variableName": "userId"
};
return {
  "kind": "Fragment",
  "name": "HpRespLayout_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "homepageId",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "fetchInitialHomepage",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "userId",
      "type": "String!"
    },
    {
      "kind": "RootArgument",
      "name": "hasUserId",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "homepage",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "rootId",
          "variableName": "homepageId"
        }
      ],
      "concreteType": "Homepage",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "modules",
          "storageKey": null,
          "args": null,
          "concreteType": null,
          "plural": true,
          "selections": [
            {
              "kind": "Condition",
              "passingValue": true,
              "condition": "fetchInitialHomepage",
              "selections": [
                {
                  "kind": "InlineFragment",
                  "type": "SkinnyBannerModule",
                  "selections": [
                    (v0/*: any*/),
                    {
                      "kind": "FragmentSpread",
                      "name": "HpRespSkinnyBannerModule_componentModule",
                      "args": null
                    }
                  ]
                },
                {
                  "kind": "InlineFragment",
                  "type": "TopHeroBannerModule",
                  "selections": [
                    (v0/*: any*/),
                    {
                      "kind": "FragmentSpread",
                      "name": "HpRespTopHeroBannerModule_componentModule",
                      "args": null
                    }
                  ]
                },
                {
                  "kind": "InlineFragment",
                  "type": "HeroModule",
                  "selections": [
                    (v0/*: any*/),
                    {
                      "kind": "FragmentSpread",
                      "name": "HpRespHeroModuleOld_componentModule",
                      "args": null
                    }
                  ]
                },
                {
                  "kind": "InlineFragment",
                  "type": "CollectionsModule",
                  "selections": [
                    (v0/*: any*/),
                    {
                      "kind": "FragmentSpread",
                      "name": "HpRespCollectionsModuleOld_componentModule",
                      "args": null
                    }
                  ]
                },
                {
                  "kind": "InlineFragment",
                  "type": "FeaturedModule",
                  "selections": [
                    (v0/*: any*/),
                    {
                      "kind": "FragmentSpread",
                      "name": "HpRespFeaturedModule_componentModule",
                      "args": null
                    }
                  ]
                },
                {
                  "kind": "InlineFragment",
                  "type": "PromoModule",
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "totalItemsCount",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "index",
                      "args": null,
                      "storageKey": null
                    },
                    (v0/*: any*/),
                    {
                      "kind": "FragmentSpread",
                      "name": "HpRespPromoModulePrimaryOld_componentModule",
                      "args": null
                    },
                    {
                      "kind": "FragmentSpread",
                      "name": "HpRespPromoModuleSecondaryOld_componentModule",
                      "args": null
                    }
                  ]
                },
                {
                  "kind": "InlineFragment",
                  "type": "EditorialModule",
                  "selections": [
                    (v0/*: any*/),
                    {
                      "kind": "FragmentSpread",
                      "name": "HpRespEditorialModule_componentModule",
                      "args": null
                    }
                  ]
                },
                {
                  "kind": "InlineFragment",
                  "type": "ShopByModule",
                  "selections": [
                    (v0/*: any*/),
                    {
                      "kind": "FragmentSpread",
                      "name": "HpRespShopByModule_componentModule",
                      "args": null
                    }
                  ]
                },
                {
                  "kind": "InlineFragment",
                  "type": "LocationsModule",
                  "selections": [
                    (v0/*: any*/),
                    {
                      "kind": "FragmentSpread",
                      "name": "HpRespLocationsModule_componentModule",
                      "args": null
                    }
                  ]
                },
                {
                  "kind": "InlineFragment",
                  "type": "ArrivalsModule",
                  "selections": [
                    (v0/*: any*/),
                    {
                      "kind": "FragmentSpread",
                      "name": "HpRespPersonalizedCategories_componentModule",
                      "args": null
                    }
                  ]
                },
                {
                  "kind": "InlineFragment",
                  "type": "RecentlyViewedModule",
                  "selections": [
                    (v0/*: any*/),
                    {
                      "kind": "FragmentSpread",
                      "name": "HpRespRecentlyViewedItems_componentModule",
                      "args": null
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          "kind": "Condition",
          "passingValue": true,
          "condition": "hasUserId",
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "personalization",
              "storageKey": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "first",
                  "value": 3
                },
                {
                  "kind": "Literal",
                  "name": "numItems",
                  "value": 3
                },
                (v1/*: any*/)
              ],
              "concreteType": "PersonalizationModuleConnection",
              "plural": false,
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "HpRespPersonalizedCategories_personalization",
                  "args": null
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "HpRespPersonalizedCategories_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "HpRespLocationsModule_viewer",
      "args": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "hasUserId",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "user",
          "storageKey": null,
          "args": [
            (v1/*: any*/)
          ],
          "concreteType": "User",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "HpRespRecentlyViewedItems_user",
              "args": null
            }
          ]
        }
      ]
    }
  ]
};
})();
(node as any).hash = '5bcc2e65d5e2083a837c9953dd9227e6';
export default node;
